import type { CSS } from '@meterup/atto';
import { fadeMaskCSS, styled } from '@meterup/atto';

import { sidebarVars } from './vars';

export const SidebarScroll = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'auto',
  ...fadeMaskCSS(`$${sidebarVars.padding.ends}`, 'vertical'),
} as CSS);
SidebarScroll.displayName = 'SidebarScroll';
